import { render } from "./RadioPage.vue?vue&type=template&id=a2d3dfb6&scoped=true"
import script from "./RadioPage.vue?vue&type=script&lang=js"
export * from "./RadioPage.vue?vue&type=script&lang=js"

import "./RadioPage.vue?vue&type=style&index=0&id=a2d3dfb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2d3dfb6"]])

export default __exports__